"use strict";

import $ from "jquery";

class Expandable
{
    constructor(target, trigger) {
        this.target = $(target);
        this.trigger = trigger; // just a selector is required
        this.threshold = this.target.data("expandable-threshold") || 0;

        // Required.
        if (this.target.length < 1 || this.trigger.length < 1) {
            return;
        }

        this.setup();
    }

    setup() {
        this.target.each((index, el) => {
            const $el = $(el);
            const children = $el.children();
            const activeFilters = ($el.find('input[type="checkbox"]:checked').length > 0);

            if (children.length > this.threshold) {
                const $toggle = $el.parent().find(this.trigger);
                const hidden = [];

                if ($toggle.length > 0) {
                    $toggle.show();

                    // Hide the excess children.
                    children.slice(this.threshold, children.length).each((index, el) => {
                        hidden.push(el);
                        // this check is reversed to allow the generic updateToggle function to be used
                        if (!activeFilters) {
                            $toggle.addClass("open");
                        }
                    });

                    this.updateToggle($toggle, hidden);

                    this.listener($toggle, hidden);
                }
                else {
                    $toggle.remove();
                }
            }
        });
    }

    listener($toggle, hidden) {
        $toggle.on("click", (event) => {
            event.preventDefault();
            this.updateToggle($toggle, hidden);
        });
    }

    updateToggle($toggle, hidden) {
        const classname = $toggle.data("expandable-target") + "--hidden";

        if ($toggle.hasClass("open")) {
            $toggle.removeClass("open");
            $(hidden).addClass(classname);

            // Optional param, if we have text.
            if ($toggle.data("expandable-text-more")) {
                $toggle.text($toggle.data("expandable-text-more"));
            }

            // Optional param, if we have a icon.
            if ($toggle.data("expandable-toggle-icon-open") && $toggle.data("expandable-toggle-icon-close")) {
                const $i = $($toggle.find("i"));
                $i.removeClass($toggle.data("expandable-toggle-icon-close"));
                $i.addClass($toggle.data("expandable-toggle-icon-open"));
            }
        }
        else {
            $toggle.addClass("open");
            $(hidden).removeClass(classname);

            // Optional param, if we have text.
            if ($toggle.data("expandable-text-less")) {
                $toggle.text($toggle.data("expandable-text-less"));
            }

            // Optional param, if we have a icon.
            if ($toggle.data("expandable-toggle-icon-open") && $toggle.data("expandable-toggle-icon-close")) {
                const $i = $($toggle.find("i"));
                $i.addClass($toggle.data("expandable-toggle-icon-close"));
                $i.removeClass($toggle.data("expandable-toggle-icon-open"));
            }
        }
    }
}

export default Expandable;
